<template>
  <div class="form-group form-group--read-only">
    <div class="row">
      <div :class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <div class="lead">
          <span
            v-if="component.prefix"
            class="prefix"
          >
            {{ component.prefix }}
          </span>
          <span class="text">{{ getValue() }}</span>
          <li
            v-for="label in labels"
            :key="label"
          >
            {{ label }}
          </li>
          <span
            v-if="component.suffix"
            class="suffix"
          >
            {{ component.suffix }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['component', 'components', 'value'],
  name: 'SelectReadOnly',
  computed: {
    labels () {
      if (Array.isArray(this.value)) {
        const l = []
        this.value.forEach(el => {
          if (Array.isArray(el.label)) {
            return el.label.forEach(lab => l.push(lab))
          }

          l.push(el.label)
        })

        return l
      }
      return []
    }
  },
  methods: {
    getValue: function () {
      if (!(Array.isArray(this.value))) {
        return this.value && this.value.hasOwnProperty('label') ? this.value.label : '-'
      }
    }
  },
  created () {
  }
}
</script>
